import { render } from "./HeroiconsOutlineCamera.vue?vue&type=template&id=f7d96602"
const script = {}

import exportComponent from "/var/www/doughcoteam.co.uk/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineCamera.vue"]])

export default __exports__